import type { VoidFunctionComponent } from 'react';

import List from '../../../../generic/List';
import PaginationFooter from '../../../../generic/Pagination/PaginationFooter';
import usePaginatedReleases from '../../../../shared/releaseGroups/hooks/usePaginatedReleases';
import type { RouterProps } from '../../../../../types';

import ReleasesListBody from './ReleasesListBody';
import ReleasesListHeader from './ReleasesListHeader';

type Props = RouterProps<{ projectGroupId: string }>;

/**
 * ReleaseGroupReleasesList is the /releases route,
 * which lists the releases for the release group and
 * has the link to the edit and clone pages for each release.
 */
const ReleaseGroupReleasesList: VoidFunctionComponent<Props> = ({ params }) => {
  const {
    releases,
    total,
    page,
    count,
    isLoading,
    setPage,
    setCount,
  } = usePaginatedReleases(params.projectGroupId);
  return (
    <div className="container margin-top-xl">
      <List>
        <ReleasesListHeader
          count={total ?? 0}
          isLoading={isLoading}
        />
        <List.Body>
          <ReleasesListBody
            count={count}
            total={total}
            isLoading={isLoading}
            releases={releases}
          />
        </List.Body>
      </List>
      <PaginationFooter
        page={page}
        count={count}
        totalItems={total ?? 0}
        setPage={setPage}
        setCount={setCount}
      />
    </div>
  );
};

export default ReleaseGroupReleasesList;
